import { render, staticRenderFns } from "./ListAcademic_degree.vue?vue&type=template&id=5525b990&scoped=true"
import script from "./ListAcademic_degree.vue?vue&type=script&lang=js"
export * from "./ListAcademic_degree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5525b990",
  null
  
)

export default component.exports